import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@chakra-ui/react';
const AdminListPageLayout = ({ children })=>/*#__PURE__*/ _jsx(Box, {
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
        minHeight: 0,
        height: "100%",
        width: "100%",
        children: children
    });
AdminListPageLayout.displayName = 'AdminListPageLayout';
export { AdminListPageLayout };
